import {inject, Injectable, signal} from '@angular/core';
import {ENV_TOKEN, EnvInterface} from 'env-config';

@Injectable({ providedIn: 'root' })
export class SessionExpireService {
  private timer!: number;
  private environment = inject(ENV_TOKEN) as EnvInterface;
  private sessionTimeout = this.environment.security.autoLogoutMinutes * 60 * 1000;
  sessionExpiredSignal = signal(false); // Signal for session expiration

  constructor(
  ) {
    // this.startSessionTimer();
  }

  startSessionTimer() {
    // this.timer = window.setTimeout(() => {
    //   this.logoutDueToInactivity();
    // }, this.sessionTimeout);
  }

  resetSessionTimer() {
    // window.clearTimeout(this.timer);
    // this.startSessionTimer();
  }

  private logoutDueToInactivity() {
    // Trigger signal event for session expiration
    //this.sessionExpiredSignal.set(true);
  }
}
